import { axiosInstance } from "./api";

export const getOrder1 = async (id = null, number = null) => {
  const res = await axiosInstance.get(`/api/v2/order/${id}`);
  return res.data;
};

export const getOrderProducts = async (id) => {
  const res = await axiosInstance.get(`/api/v2/order/${id}/products`);
  return res.data;
};

export const getOrderInventoryDetails = async (id) => {
  const res = await axiosInstance.get(`/api/v2/order/${id}/inventoryDetails`);
  return res.data;
};

export const fetchOrderFullData = async (id) => {
  if (!id) {
    throw new Error('Order ID is required');
  }

  const [order, products] = await Promise.all([
    getOrder1(id),
    getOrderProducts(id)
  ]);

  const inventoryDetails = await getOrderInventoryDetails(id);

  return {
    order,
    products,
    inventoryDetails
  };
};